"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
exports.BarValue = function (props) {
    var value = props.value, color = props.color;
    return (react_1.default.createElement(react_2.ProgressIndicator, { styles: {
            progressBar: {
                background: color,
                height: '8px'
            },
            progressTrack: {
                display: 'none'
            }
        }, percentComplete: value }));
};
//# sourceMappingURL=BarValue.js.map